import React, { Component, useRef, useCallback } from 'react';
import moment from 'moment';
import {
    format, startOfMonth, endOfMonth, differenceInCalendarDays, addDays, getMonth, getYear,
    endOfToday, startOfToday, isBefore, isAfter, isSameDay, isMonday, isTuesday, isWednesday, isThursday,
    isFriday, isSaturday, isSunday
} from 'date-fns';
import commonFunction from '../../../../lib/utils/common';
import ModalPopupComponent from '@/commonComponents/ModalPopupComponent/theme12/ModalPopupComponent.js';
// import styles from "./calendar.module.css";

const MonthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const weekList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

class MobileCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFormat: !commonFunction.isValueEmpty(this.props.dateFormat) ? this.props.dateFormat : "dd/MM/yyyy",
            isCalendarVisible: false,
            numberOfClicks: 0,
            twoCalendarsArray: [],
            isDoubleSelection: !commonFunction.isValueEmpty(this.props.doubleSelection) ? this.props.doubleSelection : false,
            dateLimitArr: this.props.startDateLimit,
            currentMonths: [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: startOfMonth(startOfToday()),
            selectedMonthEndDate: endOfMonth(startOfMonth(new Date())),
            endDate: this.props.endDate,
            hoverEndDate: this.props.endDate,
            totalDays: "",
            totalNights: '',
            pageX: "",
            pageY: "",
            initPageX: "",
            initPageY: "",
            totalMonths: !commonFunction.isValueEmpty(this.props.totalMonths) ? this.props.totalMonths : 12,
            serviceType: this.props.serviceType ? this.props.serviceType : ""
        };
        this.debouncedOnClickDateCell = this.debounce(this.onClickDateCell,1);
    }

    componentDidMount() {
        this.setState({
            currentMonths: this.props.type === "double" ? !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))),
                getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))) + 1] :
                [getMonth(startOfMonth(new Date())), getMonth(startOfMonth(new Date())) + 1] : !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))))] :
                [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: !commonFunction.isValueEmpty(this.state.dateLimitArr) ? startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))) : startOfMonth(startOfToday()),
        })
    }
    componentDidUpdate() {
        if (this.props.endDate !== this.state.endDate) {
            this.setState({ endDate: this.props.endDate });
        }
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside = () => {
        if (this.state.isCalendarVisible === true) this.setState({ isCalendarVisible: false });
    };

    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    specDateEle(date, type) {
        try {
            let toDefaultFormat = moment(date, this.state.dateFormat);
            let getDate = toDefaultFormat.format(this.state.dateFormat);
            let getYear = typeof date === 'string' ? new Date(getDate).getFullYear() : date.getFullYear();
            let getMonth = typeof date === 'string' ? new Date(getDate).getMonth() : date.getMonth();
            let getDay = typeof date === 'string' ? new Date(getDate).getDate() : date.getDate();
            switch (type) {
                case 'y':
                    return getYear;
                case 'm':
                    return getMonth;
                case 'd':
                    return getDay;
                case 'a':
                    return [getYear, getMonth, getDay];
                default:
                    return null;
            }
        } catch (err) {
            console.log('Error in specDateEle:', err);
            return null;
        }
    }

    onClickChangeVisibility = () => {
        this.props.changeVisibility(!this.props.isVisible);
    }

    onClickDateCell = (day, month, year, bool) => {
        if (!bool) {
            if (this.state.isDoubleSelection === true) {
                let date = new Date(year, month, day);
                if (this.state.numberOfClicks === 0) {
                    let differenceInDays = differenceInCalendarDays(new Date(addDays(new Date(date), 1)), new Date(date));
                    this.setState({ numberOfClicks: 1, totalNights: differenceInDays > 0 ? differenceInDays : '' }, () => {
                        this.props.onChangeDate(date, 'startDate');
                        this.props.onChangeDate(addDays(new Date(date), 1), 'endDate');
                    });
                } else if (this.state.numberOfClicks === 1) {
                    let differenceInDays = differenceInCalendarDays(new Date(date), new Date(this.props.startDate));
                    if (differenceInDays < 0) {
                        this.setState({ numberOfClicks: 0, totalNights: differenceInDays > 0 ? differenceInDays : '' }, () => {
                            this.props.onChangeDate(date, 'startDate');
                            this.props.onChangeDate(addDays(new Date(date), 1), 'endDate');
                        });
                    } else {
                        this.setState({ numberOfClicks: 0, totalNights: differenceInDays > 0 ? differenceInDays : '' }, () => {
                            this.props.onChangeDate(date, 'endDate');
                        });
                    }
                }
            } else {
                let date = moment(new Date(year, month, day)).format(this.state.dateFormat);
                this.props.onChangeDate(date);
            }
        }
    }

    renderCalendar = () => {
        let temp = this.state.selectedMonthStartDate;
        let twoCalendarsArray = [];
        for (let i = 0; i < this.state.totalMonths; i++) {
            let StartDateOfMonth = temp;
            let monthHead = addDays(StartDateOfMonth, i === 0 ? 0 : 1);
            let endDateOfMonth = endOfMonth(monthHead);
            let dayDifference = differenceInCalendarDays(endDateOfMonth, monthHead);
            let days = [];
            let month = getMonth(monthHead);
            let year = getYear(monthHead);
            let startOfMonthDay = isMonday(monthHead)
            ? 0
            : isTuesday(monthHead)
            ? 1
            : isWednesday(monthHead)
            ? 2
            : isThursday(monthHead)
            ? 3
            : isFriday(monthHead)
            ? 4
            : isSaturday(monthHead)
            ? 5
            : 6;
            let startDateLimit = this.props.startDateLimit;
            let isHoliday = this.props.isHoliday ? this.props.isHoliday : false;
            let holidayStartDate = this.props.holidayStartDate ? this.props.holidayStartDate : '';
            let holidayEndDate = this.props.holidayEndDate ? this.props.holidayEndDate : '';
            let startDate = this.props.startDate;
            let endDate = this.state.endDate;
        let hoverDate = this.state.hoverEndDate;

            for (let k = 0; k < startOfMonthDay; k++) {
                days.push({ day: "", month: month, year: year, isDisable: true, selectedDate: false, highlight: false });
            }
            for (let j = 0; j <= dayDifference; j++) {
                let isBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(startDateLimit, 'y'), this.specDateEle(startDateLimit, 'm'), this.specDateEle(startDateLimit, 'd')));
                // Only disable dates before today unless user is actively selecting a new check-in (numberOfClicks === 1)
                let isBeforeCheckIn = false;
                if (this.state.numberOfClicks === 1 && this.props.startDate) {
                    isBeforeCheckIn = isBefore(
                        new Date(year, month, j + 1),
                        new Date(
                            this.specDateEle(this.props.startDate, 'y'),
                            this.specDateEle(this.props.startDate, 'm'),
                            this.specDateEle(this.props.startDate, 'd')
                        )
                    );
                } else {
                    isBeforeCheckIn = isBefore(new Date(year, month, j + 1), startOfToday());
                }
                let disableDate = false;
                if (isHoliday) {
                    let isHLDBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(holidayStartDate, 'y'), this.specDateEle(holidayStartDate, 'm'), this.specDateEle(holidayStartDate, 'd')));
                    let isHLDAfterDate = isAfter(new Date(year, month, j + 1), new Date(this.specDateEle(holidayEndDate, 'y'), this.specDateEle(holidayEndDate, 'm'), this.specDateEle(holidayEndDate, 'd')));
                    disableDate = isHLDBeforeDate || isHLDAfterDate;
                }

                let isAfterThirtyNights = isAfter(
                    new Date(year, month, j + 1),
                    addDays(new Date(this.specDateEle(startDate, "y"), this.specDateEle(startDate, "m"), this.specDateEle(startDate, "d")), 30)
                );

                if (isBeforeDate || disableDate || isBeforeCheckIn || (isAfterThirtyNights && this.state.numberOfClicks !== 0)) {
                    days.push({ day: j + 1, month: month, year: year, isDisable: true, selectedDate: false, highlight: false });
                } else {
                    let isStartDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(startDate, "y"), this.specDateEle(startDate, "m"), this.specDateEle(startDate, "d")));
                    let isEndDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(endDate, "y"), this.specDateEle(endDate, "m"), this.specDateEle(endDate, "d")));
                    let isHoverDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(hoverDate, "y"), this.specDateEle(hoverDate, "m"), this.specDateEle(hoverDate, "d")));
                    days.push({ day: j + 1, month: month, year: year, isDisable: false, selectedDate: isStartDate || isEndDate, highlight: isHoverDate });
                }

                if (this.state.isDoubleSelection === true) {
                    let isBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')));
                    let isAfterDate = isAfter(new Date(year, month, j + 1), new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')));

                    if (isAfterDate && isBeforeDate) {
                        days[j].highlight = true;
                    }
                }
            }

            if (this.state.isDoubleSelection === true) {
                let startDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')).toString());
                let endDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')).toString());
                if (startDateIndex !== -1) {
                    days[startDateIndex].selectedDate = true;
                }
                if (endDateIndex !== -1) {
                    days[endDateIndex].selectedDate = true;
                }
            } else {
                let SelectedDate = this.props.value;
                let selectedDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(SelectedDate, 'y'), this.specDateEle(SelectedDate, 'm'), this.specDateEle(SelectedDate, 'd')).toString())
                if (selectedDateIndex !== -1) {
                    days[selectedDateIndex].selectedDate = true;
                }
            }
            temp = endDateOfMonth;
            twoCalendarsArray.push(
                <>
                  
                <div className={this.props.styles.calendar_whole_body} key={i}>
                 
                    <div className={this.props.styles.calendar_head}>
                        <div className={this.props.styles.calendar_head_center_side}>
                            <h3>{format(monthHead, 'MMMM yyyy')}</h3>
                        </div>
                    </div>
                    <div className={`${this.props.styles.calendar_body} ${this.props.styles.calendar_body_wrap}`}>
                      
                        <div className={this.props.styles.calendar_day_list}>
                            {days.map((ele, idx) => {
                                let isHighLight = false;
                                let isHoverDate = false;
                                if (this.state.isDoubleSelection === true) {
                                    let isBeforeDate = isBefore(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(hoverDate, 'y'), this.specDateEle(hoverDate, 'm'), this.specDateEle(hoverDate, 'd')));
                                    let isBeforeEndDate = isBefore(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')));
                                    let isAfterDate = isAfter(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')));
                                    isHoverDate = isSameDay(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(hoverDate, 'y'), this.specDateEle(hoverDate, 'm'), this.specDateEle(hoverDate, 'd')));
                                    if ((isAfterDate && isBeforeDate && commonFunction.isValueEmpty(endDate)) || (isAfterDate && isBeforeEndDate && (!commonFunction.isValueEmpty(endDate)))) {
                                        isHighLight = true;
                                    }
                                }
                                return (
                                    <div className={(ele.selectedDate === true && ele.day) ? this.props.styles.day_cell_center + ' ' + this.props.styles.selected_calendar_date : isHighLight === true && ele.day !== "" ? this.props.styles.day_cell_center_highlight : this.props.styles.day_cell_center} key={i + '_' + idx}
                                        onClick={(e) => { e.stopPropagation(); this.debouncedOnClickDateCell(ele.day, ele.month, ele.year, ele.isDisable) }} onMouseEnter={(e) => this.onHoverDayCell(ele, e)} >
                                        {this.state.isDoubleSelection === true && !commonFunction.isValueEmpty(ele.day) && ele.isDisable === false && !commonFunction.isValueEmpty(hoverDate) && isHoverDate && !commonFunction.isValueEmpty(this.state.totalDays) && <div className={this.props.styles.container_tooltip}>{this.state.totalDays} {this.state.totalDays > 1 ? 'Nights' : 'Night'}</div>}
                                        <span className={ele.isDisable === true ? this.props.styles.calendar_day_disable : ''}>{ele.day}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                </>
            )
        }
        return twoCalendarsArray;
    }

    // onClickDoneBtn = () => {
    //     this.props.changeVisibility(false);
    // }

    // onClickClearDate = () => {
    //     this.props?.changeVisibility(false);
    //     this.props?.onClearDate();
    //   };
                onClickDoneBtn = () => {
            this.props.changeVisibility(false);
            };

            onClickClearDate = () => {
            this.props.onClearDate?.();
            this.props.changeVisibility(false);
            };


    onHoverDayCell = (currentDate, e) => {
        let date = moment(new Date(currentDate.year, currentDate.month, currentDate.day)).format(this.props.dateFormat ? this.props.dateFormat : "DD/MMM/yyyy");
        this.setState({
            hoverEndDate: date
        });
        if (!commonFunction.isValueEmpty(this.props.startDate)) {
            this.setState({
                hoverEndDate: date, pageX: Number(e.clientX) - Number(this.state.initPageX), pageY: Number(e.clientY) - Number(this.state.initPageY)
            }, () => {
                let difference = differenceInCalendarDays(new Date(currentDate.year, currentDate.month, currentDate.day), new Date(this.props.startDate));
                if (difference > 0) this.setState({ totalDays: difference });
                else this.setState({ totalDays: '' });
            })
        }
    }

    selectDateLabelType() {
        let dateLabel = { calaHeadTitle1: "DEPARTURE DATE", calaHeadTitle2: "RETURN DATE" };
        if (this.state.serviceType === "hotel") {
            dateLabel.calaHeadTitle1 = "Check In";
            dateLabel.calaHeadTitle2 = "Check Out";
        } else if (this.state.serviceType === "holiday") {
            dateLabel.calaHeadTitle1 = "START DATE";
            dateLabel.calaHeadTitle2 = "END DATE";
        }
        return dateLabel;
    }

    render() {
        const checkInDt = this.props.value ? `${this.props.value.split("-")[0]}  ${this.props.value.split("-")[1] }`: "";
        const checkOutDt = this.props.value ? `${this.props.value.split("-")[3]}  ${this.props.value.split("-")[4] }`: "";
        const totalNights = this.state.totalNights ? `${this.state.totalNights} ${this.state.totalNights > 1 ? 'Nights' : 'Night'}` : `${Number(this.props.value.split("-")[3]) - Number(this.props.value.split("-")[0]) } Nights`;
        const checkInOutdt = `${checkInDt} - ${checkOutDt} `;
        
        return (
            <div onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }} className={this.props.styles.calendar_wid_container}>
               
                <div className={this.props.styles.calendar_wid_main}>
                    {!commonFunction.isValueEmpty(this.props.iconImage) ? (
                        <>
                        <img src='/images/calendar.svg'/>
                        </>
                    ) : null}
                    {this.state.isDoubleSelection === true ? (
                        <>
                        <div className={this.props.styles?.calendar_input_container}
                          onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }} >
                        <input type='text' autoComplete={'off'} id="myTextField" className="search_widget_input_new" readOnly
                            placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                            value={!commonFunction.isValueEmpty(this.props.value) ? checkInOutdt : ""}
                            onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                        />
                         <span className={this.props.styles.calendar_per_night}>{totalNights}</span>
                        </div>

                </>
                    ) : (
                        <>
                  <input type='text' autoComplete={'off'} id="myTextField" className="search_widget_input_new" readOnly
                            placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                            value={!commonFunction.isValueEmpty(this.props.value) ? this.props.value : ""}
                            onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                        />
                        </>
                    )}
                </div>
                {this.props.isVisible === true ? (
                    <div className={this.props.styles.calendar_wid_container_popup}>
                       <div className={this.props.styles?.hotel_destination_popup}>
                        <ModalPopupComponent
                        isPopup={this.props.isVisible}
                        modalCss={this.props?.PopupMobCss}

                        outSideClickBool={true}
                        onOutSideClick={(value) => {
                            this.props.changeVisibility(value);
                            document.body.style.overflow = "auto";
                        }}

                        showCrossButton={false}
                        showBackButton={false}

                        onClosePopup={() => {
                            this.props.changeVisibility(false);
                            document.body.style.overflow = "auto";
                        }}
                        >
                        <div className={this.props.styles.calendar_main_body_popup}>
                            <p className={this.props.styles.calendar_popup_title}>Select Date</p>
                            <div className={this.props.styles.calendar_week_heads}>
                            <div className={this.props.styles.coln_center_week}>Sun</div>
                            <div className={this.props.styles.coln_center_week}>Mon</div>
                            <div className={this.props.styles.coln_center_week}>Tue</div>
                            <div className={this.props.styles.coln_center_week}>Wed</div>
                            <div className={this.props.styles.coln_center_week}>Thu</div>
                            <div className={this.props.styles.coln_center_week}>Fri</div>
                            <div className={this.props.styles.coln_center_week}>Sat</div>
                            </div>

                            {this.renderCalendar()}

                            <div className={this.props.styles?.holiday_footer}>
                            <div className={this.props.styles?.holiday_date}>
                                {checkInOutdt} | {totalNights}
                            </div>

                            <div
                                className={this.props.styles?.holiday_clear}
                                role="button"
                                onClick={this.onClickClearDate}
                            >
                                Clear
                            </div>
                            </div>
                        </div>

                        <div className={this.props.styles.calendar_footer}>
                            <button onClick={this.onClickDoneBtn}>Apply</button>
                        </div>
                        </ModalPopupComponent>
                    </div>
                    
                    </div>
                ) : null}
            </div>
        )
    }
}

export default MobileCalendar;
